import { AxiosResponse } from "axios";
import AxiosService from "./Axios"
import BaseApi from "./BaseApi";

const BASE_URL = "/gateway";

class GatewayApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async saveSettings(gatewayId: string, type: string, settings: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/gateway-settings/save', {
            gatewayId: gatewayId,
            groupSettingsType: type,
            groupSettings: settings,
        });
    }

    public async getGatewayViewByGatewayId(gatewayId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/gateway-view/gateway-id/' + gatewayId);
    }

    public async invokeService(gatewayId: string, serviceKey: string, parameters: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/service/invoke', {
            gatewayId: gatewayId,
            serviceKey: serviceKey,
            parameters: parameters,
        });
    }

    public async queryViews(request: QueryGatewayViewsRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/gateway-view/query', request);
    }

}

interface QueryGatewayViewsRequest {
    pageNo: number;
    pageSize: number;

    gatewayId?: string;
    productModel?: string;
    search?: string;
}

export default GatewayApi;
